export const animations = {
  transitionFast: '0.15s ease',
  transitionBase: '0.2s ease',
  transitionSlow: '0.3s ease',
} as const;
